export const AGENT_CONTROL_SANDBOX_ENVIRONMENT_TAG = 'agentcontrol-sandbox';

export function isAgentControlSandboxEnvironment(environment: { tags?: readonly string[] }) {
  return environment.tags?.includes(AGENT_CONTROL_SANDBOX_ENVIRONMENT_TAG) ?? false;
}
